// Edgeの翻訳機能を使っているとReactのremoveChildエラーが発生する。
// その場合に処理が止まらないようにするための実装。
// [プルリクエスト](https://github.com/osintech/whale-front/pull/330)
// [参考となったissueのコメント](https://github.com/facebook/react/issues/11538#issuecomment-417504600)

import Bowser from 'bowser';

export const preventEdgeTranslatorDomCrash = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  if (browser.isBrowser('Microsoft Edge')) {
    if (typeof Node === 'function' && Node.prototype) {
      const originalRemoveChild = Node.prototype.removeChild;
      Node.prototype.removeChild = function <T extends Node>(child: T): T {
        if (child.parentNode !== this) {
          if (console) {
            console.error(
              'Cannot remove a child from a different parent',
              child,
              this
            );
          }
          return child;
        }
        return originalRemoveChild.call(this, child) as T;
      };

      const originalInsertBefore = Node.prototype.insertBefore;
      Node.prototype.insertBefore = function <T extends Node>(
        newNode: T,
        referenceNode: Node | null
      ): T {
        if (referenceNode && referenceNode.parentNode !== this) {
          if (console) {
            console.error(
              'Cannot insert before a reference node from a different parent',
              referenceNode,
              this
            );
          }
          return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
      };
    }
  }
};
